module.exports = __webpack_public_path__ + "static/don45-c3d5c971d2c75ec8cf29484e626cff05.jpg";